import React, { useState } from "react";
import Search from "../sidebar/Search";
import SearchIcon from "@material-ui/icons/Search";

import "./MobileSearch.scss";
// import { useState } from "react";

const MobileSearch = () => {
  const [searchText, setSearchText] = useState("");
  return (
    <div className="mobile-search-container">
      <Search searchText={searchText} setSearchText={setSearchText} />
      {!searchText && <SearchIcon />}
    </div>
  );
};

export default MobileSearch;
